import AppPanel from '../fw/AppPanel.react';
import React from 'react';
import PropTypes from 'prop-types';
import Relay from 'react-relay';
import DetailToolBar from '../fw/DetailToolBar.react.js';
import Grid from '../fw/Grid.react';
import DetailBox from '../fw/DetailBox.react.js';
import TableDetail from '../fw/TableDetail.react';

import urlMapping from '../app/URLMapping';
import types from '../../common/model-api/types';
import md5 from 'md5';
import {wrapNotFound} from '../app/NotFoundHandler.react';
import {getLastOrganisationId} from '../app/LastOrganisationId';

import './User.scss';
import * as BrowserPermission from "../BrowserPermission";
import { User } from '../../common/types/types';

interface UserViewProps {
    user: User;
}

class UserView extends React.Component<UserViewProps> {

    typeName = 'users';

    static propTypes = {
        user: PropTypes.object.isRequired
    };

    render() {
        const data = this.props.user.organisation.user;
        let type = types[this.typeName];

        /* ugly hack to set organisation_id so we can use our URL mapping system */
        data['organisation_id'] = this.props.user.organisation['realId'];

        const size = 64;
        let gravUrl = "https://www.gravatar.com/avatar/" + md5(data.email.toLowerCase().trim()) + "&s=" + size;

        return (
            <AppPanel breadcrumbParams={[
                {type, data},
                {type: types['organisations'], data: this.props.user.organisation}]
            } title={data.firstname + ' ' + data.surname}>
                <div>
                    <DetailBox data={data} metadata={type} urlMapping={urlMapping}>
                        <DetailToolBar data={data} metadata={type} organisationId={this.props.user.organisation.realId} urlMapping={urlMapping} />
                        <div className="userProfilePicture">
                            <img src={gravUrl} />
                            <h2 className="title">{(data.firstname ? data.firstname : '') + ' ' + (data.surname ? data.surname : null)}</h2>
                        </div>
                        <TableDetail columns={['nickname', 'company', 'email', 'otherEmails', 'phoneNumber', 'notifyErrors', 'notifyEmail']} data={data} metadata={type} />

                        <Grid
                            columns={['organisation.name', 'role']}
                            getUrl={(row) => {
                                if (types['organisation2user'].canUpdate(BrowserPermission.getPermissionObject(), row, row.organisation_id) && types['organisation2user'].canUserUpdate()) {
                                    return urlMapping.getUrl('organisation2user', 'edit', row);
                                } else {
                                    return null;
                                }
                            }}
                            list={data.accessibleOrganisation2users.edges.map(({node}) => node)}
                            metadata={types['organisation2user']}
                            urlMapping={urlMapping} />

                    </DetailBox>
                </div>
            </AppPanel>
        );
    }
}

export default Relay.createContainer(wrapNotFound(UserView, (props) => {
    return props.user.organisation && props.user.organisation.user;
}), {
    initialVariables: {
        userId: '',
        organisationId: '',
    },
    prepareVariables (variables) {
		if (!variables.organisationId) {
			variables.organisationId = getLastOrganisationId();
		}

        return variables;
    },
    fragments: {
        user: () => Relay.QL`
            fragment on User {
                organisation(id: $organisationId) {
                    id,
                    name,
                    realId,
                    user(id: $userId) {
                        id,
                        realId,
                        phoneNumber,
                        firstname,
                        surname,
                        nickname,
                        otherEmails,
                        notifyErrors,
                        notifyEmail,
                        picture,
                        company,
                        email,
                        accessibleOrganisation2users(first: 10000) {
                            edges {
                                node {
                                    id,
                                    realId,
                                    role,
                                    organisation_id,
                                    organisation {
                                        id,
                                        realId,
                                        name,
                                        description,
                                        payPlan,
                                    }
                                }
                            }
                        }
                    }
                }
            }
        `,
    },
});
